import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from '../../common/BaseComponent/BaseComponent';
import ComponentInvoiceBlock from '../ComponentInvoiceBlock/ComponentInvoiceBlock';


import whiteBox from "../../common/scss/WhiteBox.scss";
import styles from "./ComponentPaymentWayAndInvoice.scss";
import ComponentPaymentWay from "../ComponentPaymentWay/ComponentPaymentWay";
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";
import {__t} from '../../common/lang/text-resource';

class ComponentPaymentWayAndInvoice extends BaseComponent {
	static propTypes = {
		showWithWhiteBox: PropTypes.bool
	};

	companyForm = React.createRef();
	paymentWayForm = React.createRef();

	componentValidate = () => {
		let companyForm = this.companyForm.current;
		if (companyForm) {
			return companyForm.componentValidate();
		}
		return true;
	};

	getComponentState = () => {
		let companyForm = this.companyForm.current;
		let paymentWayForm = this.paymentWayForm.current;
		if (companyForm) {
			companyForm = companyForm.getComponentState();
		}
		if (paymentWayForm) {
			paymentWayForm = paymentWayForm.getComponentState();
		}
		return {
			companyData: companyForm,
			paymentWay: paymentWayForm.selectedPaymentWay,
			isAutoRenewChecked: paymentWayForm.isAutoRenewChecked,
			registeredCardSelected: paymentWayForm.registeredCardSelected,
		};
	};

	render() {
		// const {invoiceBlock, paymentWayBlock} = this.props.data.componentData;

		let invoiceBlock = this.context.get('ComponentInvoiceBlock');
		let paymentWayBlock = this.context.get('ComponentPaymentWay');
		let inCart = this.context.get(inCart);
		return (
		  <div data-layout="margin-top--lg"
			   className={`${styles.mainContainer} ${this.props.inBigCart === true ? styles.inBigCart : null} ${this.props.showWithWhiteBox ? styles.inPage : ''}`}>
			  <h1>
				  <div data-layout={this.props.showWithWhiteBox ? 'hide@md' : ''}>{__t('Плащане')}</div>
				  {
					  this.props.showWithWhiteBox ?
						<div data-layout="hide show@md">{__t('Начин на плащане')}</div> : ''
				  }
			  </h1>
			  <div className={this.props.showWithWhiteBox ? `${whiteBox.container} ${styles.container}` : ''}>

				  <ComponentPaymentWay
					data={paymentWayBlock}
					ref={this.paymentWayForm}
					showAsPage={this.props.showWithWhiteBox}/>

				  {/*<p data-layout='margin-top--smm' className={styles.additionalInfo}>*/}
				  {/*	Всички плащания са на обявената цена от поръчката и без допълнителни разходи свързани с*/}
				  {/*	разплащането*/}
				  {/*</p>*/}
				  {!inCart &&
					<div className={styles.invoiceContainer}>
						<ComponentInvoiceBlock
						  data={invoiceBlock}
						  allowNewCompany={false}
						  showInPage={this.props.showWithWhiteBox}
						  disableInvoiceBlock={this.props.disableInvoiceBlock}
						  ref={this.companyForm}/>
					</div>}

			  </div>
		  </div>
		);
	}
}


// React Context binding
ComponentPaymentWayAndInvoice.contextType = ContextDataStore;

export default ComponentPaymentWayAndInvoice;